const dayjs = require('dayjs');

function getWeekNumberOfMonth(date) {
    // Get the current date as a dayjs object
    const currentDate = dayjs(date);
    
    // Get the first day of the current month
    const firstDayOfMonth = currentDate.startOf('month');
    
    // Calculate the week number of the month
    const weekNumber = Math.ceil((currentDate.date() + firstDayOfMonth.day()) / 7);
    
    return weekNumber;
}

function getWeeklyOff(date, weeklyHoliday, userId) {
    if (!Array.isArray(weeklyHoliday) || weeklyHoliday.length === 0) return false;

    // Find the weekly off data for the given user
    const weeklyOffData = weeklyHoliday.find(item =>
        item.user.some(user => user.id === userId)
    );

    if (!weeklyOffData) return false;

    const dayName = dayjs(date).format('dddd');
    const currentWeek = getWeekNumberOfMonth(date); 
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    
    // Get the index for startDay and endDay
    const startIndex = days.indexOf(weeklyOffData.startDay);
    const endIndex = days.indexOf(weeklyOffData.endDay);
    const currentDayIndex = days.indexOf(dayName);

    // Return false if start or end day is invalid
    if (startIndex === -1 || endIndex === -1) return false;
    
    // Check for special off week and day
    if (Array.isArray(weeklyOffData.specialOffWeek) && 
        weeklyOffData.specialOffWeek.includes(currentWeek) && 
        Array.isArray(weeklyOffData.specialOffDay) && 
        weeklyOffData.specialOffDay.includes(dayName)) {
        return false;  // It's a special off week and day
    }

    // Calculate the regular weekly off
    if (startIndex <= endIndex) {
        // If the weekly off period is within a single week (start before end)
        return currentDayIndex >= startIndex && currentDayIndex <= endIndex;
    } else {
        // If the weekly off period spans across the week (start after end)
        return currentDayIndex >= startIndex || currentDayIndex <= endIndex;
    }
}
module.exports = getWeeklyOff;

